import { VatSupportedStatusInversed } from '@teinor/erp/types/company/accounting/vatSupported'
import { useParams } from 'react-router-dom'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import VatSupportedFinishedStep from './Steps/VatSupportedFinishedStep'
import useVatLayoutScreenLogic from '../../../../../../specificComponents/inputTableLayouts/vat/VatLayout/useVatLayoutScreenLogic'

interface SingleVatSupportedProps extends TableComponentProps {}

const SingleVatSupported: React.FC<SingleVatSupportedProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const VatSupportedId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/accounting/vatSupported/vatSupportedLine/createVatSupportedLine', { VatSupportedId }],
        getData: ['/api/app/accounting/vatSupported/getVatSupportedComplete', { id: VatSupportedId }],
        updateData: '/api/app/accounting/vatSupported/vatSupportedLine/updateVatSupportedLine',
        delete: '/api/app/accounting/vatSupported/vatSupportedLine/deletevatSupportedLine',
        updateHeaderData: '/api/app/accounting/vatSupported/updateVatSupported',
        updateOrderLines: '',
        printTags: ''
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration } = useVatLayoutScreenLogic({ inputTableURLs, userPermissions })
    const status = parseInt(completeData?.header.status)
    if (status === VatSupportedStatusInversed['finished']) {
        return <VatSupportedFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration }} />
    }
    return null
}

export default SingleVatSupported